// Note: this file is a **temporary** copy of the logger.js file from the
// joystagram-components package. This is needed because we cannot import a
// CommonJS module into an ES module in Node 18. When we can - most likely
// after updating to Node 20 - we should import the logger.js file directly and
// then delete this file.

import * as Sentry from '@sentry/nextjs';

const isClient = typeof window !== 'undefined';

const getPublicEnvVar = envName => process.env[envName] ?? '';

const isProd = (
  globalThis._env_?.NEXT_PUBLIC_ENV_NAME ||
  getPublicEnvVar('NEXT_PUBLIC_ENV_NAME')
)?.includes('prod');

/** Note: All of these logging functions only log to the browser console in
 * non-production environments, so can be safely used without outputting to the
 * browser console in prod. The error functions also report any errors to Sentry. */

// This function should be called if there is a critical error which prevents
// users from using core functionality, e.g. if user hits a 404 page or is
// unable to connect to the Alexandria GraphQL API.
export const logCriticalError = (err, type) => {
  const errorArray = ['logCriticalError:', err, type].filter(Boolean);

  // In non prod environments or when running on the server, log full error details to console
  if (!isProd || !isClient) {
    // eslint-disable-next-line no-console
    console.error(...errorArray);
  }

  Sentry.withScope(scope => {
    scope.setLevel('critical');
    scope.setTag('JB4.0-CRITICAL', 'true');

    if (isClient) {
      scope.setTag('URL', document.location.href);
    }

    scope.setTag('ERRORTYPE', type);
    Sentry.captureException(err);
  });
};

// This function should be called if a non-critical error occurs
export const logError = (err, messageOrTags, extras) => {
  const tags =
    typeof messageOrTags === 'string'
      ? { message: messageOrTags }
      : messageOrTags;

  const errorArray = ['logError:', err, tags, extras].filter(Boolean);

  // In non prod environments or when running on the server, log full error details to console
  if (!isProd || !isClient) {
    // eslint-disable-next-line no-console
    console.error(...errorArray);
  }

  Sentry.withScope(scope => {
    if (isClient) {
      scope.setTag('URL', document.location.href);
    }

    if (tags) {
      Object.keys(tags).forEach(key => {
        scope.setTag(key, tags[key]);
      });
    }

    if (extras) {
      Object.keys(extras).forEach(key => {
        scope.setExtra(key, extras[key]);
      });
    }

    Sentry.captureException(err);
  });
};

// This function should be called to log any extra debugging info to the console
export const logInfo = (...debugData) => {
  if (!isProd) {
    const debugDataArray = ['logInfo:', ...debugData].filter(Boolean);
    // eslint-disable-next-line no-console
    console.info(...debugDataArray);
  }
};
